import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faEnvelope,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

const BasicInformation = ({ user }) => {
  return (
    <div className="basic-information">
      <h4>
        {user.first_name} {user.last_name}
      </h4>
      {user.title && (
        <p>
          {user.title} at {user.company}
        </p>
      )}

      <ul>
        {user.city && <li className="location">{user.city}</li>}
        <li className="mb-2">
          <FontAwesomeIcon icon={faPhone} className="me-3" />
          {user.phone}
        </li>
        <li className="mb-2">
          <FontAwesomeIcon icon={faEnvelope} className="me-3" />
          {user.email}
        </li>
        {user.is_avatar_verified && (
          <li>
            <FontAwesomeIcon
              icon={faCheckCircle}
              className={`${user.is_id_verified ? "text-success" : ""} me-3`}
            />
            Profile verified for Showroom experience
          </li>
        )}
      </ul>
    </div>
  );
};

export default BasicInformation;
